export enum MessageCategories {
  Applications = 1,
}
export enum MessageStatuses {
  New = 1,
  Read,
}
